<template>
    <v-form
        ref="form"
        :model="input"
        :action="endpoint"
        :method="method"
        @submitted="handleSubmitted"
        :validate="validate"
    >
        <template scope="{ error, errorState }">
            <b-tabs>
                <b-tab title="Message"
                       active>

                    <v-input-field
                        label="Title"
                        description="The title for the message."
                        v-model="input.title"
                        :error="error('title')"
                        :state="errorState('title')"
                        placeholder="Enter Title"/>

                    <v-input-field
                        label="Subtitle"
                        description="The subtitle for the message."
                        v-model="input.subtitle"
                        :state="errorState('subtitle')"
                        :error="error('subtitle')"
                        placeholder="Enter Subtitle"/>

                    <speaker-field
                        label="Speaker"
                        v-model="input.speaker"
                        description="Add a speaker for the series."
                        :state="errorState('speaker')"
                        :error="error('speaker')"/>

                    <v-rich-text-field
                        label="Description"
                        description="The message description"
                        :state="errorState('description')"
                        v-model="input.description"
                        placeholder="Enter Description."
                        error="error('description')"/>
                </b-tab>

                <b-tab title="Notes">
                    <notes-field v-model="input.notes"
                                 ref="notes" :parent="parent"/>
                </b-tab>
            </b-tabs>
        </template>
    </v-form>
</template>

<script>
    import Form from './Form'

    export default {
        extends: Form,
        props: ['parent'],
        computed: {
            endpoint()
            {
                if (this.exists) {
                    return `/messages/${this.message.parent.id}/campuses/${this.message.campus_id}/messages/${this.message.id}`
                } else {
                    return "/messages/"
                }
            }
        }
    }
</script>
